import uuidv4 from 'uuid/v4';

import { IBackendCartEntries, ICartEntry } from '@rbi-ctg/menu';
import { CartEntryType } from 'utils/cart';
import { parseStringifiedJSON } from 'utils/parse-string';
import { IWithVendorConfig } from 'utils/vendor-config';

const emptyJsonObj = '{}';
// pricing function for children items to return undefined
// so to prevent the total price double in the cart
const childPricingFunction = (isChildOfCombo?: boolean) => () => (isChildOfCombo ? undefined : 0);

export const mapBackendToFrontend = (
  pricingFunction: (item: IWithVendorConfig, quantity?: number) => number | undefined,
  priceItemOptionModifier: (
    cartEntry: IBackendCartEntries
  ) => ((cartEntry: IBackendCartEntries) => number) | number = () => 0
) => (cartEntry: IBackendCartEntries): ICartEntry => {
  const price =
    cartEntry.type === CartEntryType.itemOptionModifier
      ? (priceItemOptionModifier(cartEntry) as number) // this will always be the child of an item, so priceItemOptionModifier is already called with a cart entry
      : pricingFunction({ vendorConfigs: cartEntry.vendorConfigs }, cartEntry.quantity);

  const nextPriceItemOptionModifier =
    cartEntry.type === CartEntryType.item
      ? priceItemOptionModifier(cartEntry)
      : priceItemOptionModifier;

  const id = cartEntry.sanityId || '';
  return {
    _id: id,
    cartId: uuidv4(),
    children: cartEntry.children
      ? cartEntry.children.map(
          mapBackendToFrontend(
            childPricingFunction(
              [CartEntryType.combo, CartEntryType.comboSlot].includes(cartEntry.type)
            ),
            nextPriceItemOptionModifier as (cartEntry: IBackendCartEntries) => number
          )
        )
      : [],
    image: parseStringifiedJSON({ value: cartEntry.image || emptyJsonObj }),
    name: cartEntry.name || '',
    pickerSelections: parseStringifiedJSON({ value: cartEntry.pickerSelections || emptyJsonObj }),
    price,
    quantity: cartEntry.quantity,
    sanityId: id,
    type: cartEntry.type,
    url: cartEntry.url,
    offerVendorConfigs: cartEntry.offerVendorConfigs,
    vendorConfigs: cartEntry.vendorConfigs
  };
};
